module.exports = __webpack_public_path__ + "img/clubprophet-logo.bf2200b8.png";